export const collectionFAQMicroData = (list, title) => {
  const isBluelightCollection = title.title.toLowerCase().includes('bluelight');
  const isFrenchLocale = title.node_locale.includes('fr');
  const isFrenchBluelightCollection = isFrenchLocale && isBluelightCollection;

  // Specific data for french bluelight category
  const frenchBluelightFAQ = [
    {
      '@type': 'Question',
      name: '1. Qu’est ce que la lumière bleue ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "La lumière visible par nos yeux est composée de lumière rouge, jaune, verte, bleu et violette. La lumière bleue est la plus énergétique du spectre visible. Plus la lumière est énergétique, plus celle-ci sera dangereuse pour l'œil. Celle-ci se situe juste après les Ultra violet dont nous nous protégeons avec les lunettes de soleil. Sur le spectre de la lumière visible, la lumière bleue se divise en deux types de rayonnement très différents. La lumière « bleu-turquoise » (de 455 nm à 495 nm) est reconnue vitale à l’organisme. Elle contribue à notre éveil, notre endormissement, notre bien-être d’une manière générale. D’autre part, la lumière bleu-violet (de 380 nm à 455 nm) accélère le vieillissement de nos cellules et génère les maux de tête/fatigue oculaire. En partie filtrée par le cristallin, elle pénètre en profondeur dans l’œil et vient frapper la rétine sur sa partie centrale.",
      },
    },
    {
      '@type': 'Question',
      name: '2. D’où vient la lumière bleue ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "La lumière bleue est une lumière à forte intensité énergétique qui est émise par le soleil. C’est la source principale d'émission de cette lumière. Cependant, on constate que la lumière bleue est également omniprésente dans les sources lumineuses artificielles, notamment dans les éclairages économes en énergie (LED) et les écrans électroniques mais le niveaux d'éclairage est alors trop faible. C’est cet éclairement modéré qui rend alors la lumière bleue dangereuse pour nos yeux. L’exposition excessive à ces sources dont la lumière bleue est jugée trop agressive est prouvée comme étant l’origine de certains changements pathologiques.",
      },
    },
    {
      '@type': 'Question',
      name: '3. Comment réduire l’impact de la lumière bleue ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Il existe plusieurs solutions pour réduire l’impact de la lumière bleue : Limiter le recours aux écrans Adapter ses ampoules LED et privilégier les température blanc chaud Mettre un filtre sur ses écrans, que ce soit celui d’un mode nuit ou d’une application dédiée. Adopter des lunettes anti-lumière bleue. C’est cette dernière solution qui vous assurera la meilleure protection face à la lumière bleue. Les lunettes anti-lumière bleue protègent vos yeux du travail sur écran. Les verres filtrent la lumière bleue pour offrir une atmosphère plus relaxante et plus chaleureuse et améliorer la vision sur écran notamment dans un environnement sombre. C’est pour cela que Nooz a à coeur de proposer les meilleures lunettes anti-lumière bleue possible : grâce à des verres ultra-protecteurs, nos lunettes filtrent la lumière bleue afin de bloquer les rayons nocifs provenant d’écrans digitaux. Pour s’assurer que vous n’ayez pas le réflexe de retirer vos lunettes, nos verres anti-lumière bleue reposent sur une monture ultra-confortable que vous oublierez lorsque vous regardez votre écran. Les lunettes Nooz anti-lumière bleue sont extrêmement, vous permettant de les conserver le plus longtemps possible.',
      },
    },
  ];

  const returnQuestionsAnswersFAQ = () => {
    const questionsAnswersFAQ = [];

    const returnSingleParagraph = (body) => {
      let rawParagraphs = '';
      body.forEach((paragraph, index) => {
        const space = index === 0 ? '' : ' ';
        if (paragraph.content[0] && paragraph.content[0].value) {
          // Add each value from body to get only one paragraph
          rawParagraphs += `${space}${paragraph.content[0].value}`;
        }
      });
      const paragraphs = rawParagraphs.replace(/\n|\r/g, '');
      return paragraphs;
    };

    list.items.forEach((component) => {
      const questionAnswer = {};
      component.items.forEach((item) => {
        // Create question and answer object from current index
        if (item.key === 'label') {
          questionAnswer.question = item.text;
        } else if (item.key === 'body') {
          const rawBody = JSON.parse(item.richBody.raw).content;
          const cleanBody = returnSingleParagraph(rawBody);
          questionAnswer.answer = cleanBody;
        }
      });
      // Push every question and answer in array
      if (questionAnswer.question && questionAnswer.answer) {
        questionsAnswersFAQ.push(questionAnswer);
      }
    });

    return questionsAnswersFAQ;
  };

  const questionsAnswersFAQ = returnQuestionsAnswersFAQ(list);
  const formatedQuestionsAnswersFAQ = questionsAnswersFAQ.map(
    (questionAnswer) => ({
      '@type': 'Question',
      name: questionAnswer.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: questionAnswer.answer,
      },
    })
  );

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: isFrenchBluelightCollection
      ? frenchBluelightFAQ
      : formatedQuestionsAnswersFAQ,
  };
};
